import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import NoLayout from "../views/layouts/no-layout.vue";
import RoleLayout from "../views/layouts/role-layout.vue";
// Static
import HomePage from "../views/home";
import DefaultPage from "../views/dashboards";
import Default1Page from "../views/dashboards/show-all.vue";

// Auth
import LoginPage from "../views/auth/login.vue";
import RoleLoginPage from "../views/auth/role-login.vue";
import ResetPasswordPage from "../views/auth/reset-password.vue";
// ------------------------------------------------------------------------------------------
// Super Admin
// Users
import UsersPage from "../views/users";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";

// Projects
import ProjectsPage from "../views/projects";
import ProjectCreatePage from "../views/projects/create.vue";
import ProjectIdPage from "../views/projects/id.vue";

// Templates
import TemplatesUpload from "../views/projects/upload.vue";
import TemplatesPage from "../views/projects";
import TemplateCreatePage from "../views/projects/create.vue";
import TemplateIdPage from "../views/projects/id.vue";

// Quotations
import QuotationsUpload from "../views/projects/upload.vue";
import QuotationsPage from "../views/projects";
import QuotationCreatePage from "../views/projects/create.vue";
import QuotationIdPage from "../views/projects/id.vue";

// Modules
import ModulesPage from "../views/modules";
import ModuleTreePage from "../views/modules/tree.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// ModuleJobs
import ModuleJobsPage from "../views/module-jobs";

// Values
// import ValuesUpload from "@/views/values/upload.vue";
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// User Permission
import UserPermissions from "@/views/user-permissions/index.vue";
// ValueLists
// import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueLists from "@/views/value-lists/index.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";
// Suppliers
import SuppliersPage from "../views/suppliers";
import SupplierCreatePage from "../views/suppliers/create.vue";
import SupplierIdPage from "../views/suppliers/id.vue";
const routes = [
  // Redirect root to login page
  {
    path: "/",
    redirect: "/auth/login",
  },
  // UnAuthLayout
  {
    path: "",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [],
  },
  //End UnAuthLayout

  // NoLayout
  {
    path: "",
    name: "NoLayout",
    component: NoLayout,
    children: [
      {
        path: "/auth/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/superadmin/login",
        name: "SuperAdminLoginPage",
        component: RoleLoginPage,
      },
      {
        path: "/admin/login",
        name: "AdminLoginPage",
        component: RoleLoginPage,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
      },
    ],
  },
  // End NoLayout
  // RoleLayout
  {
    path: "",
    name: "RoleLayout",
    component: RoleLayout,
    children: [
      {
        path: "/dashboards",
        name: "DefaultPage",
        component: DefaultPage,
      },
      {
        path: "/dashboards/show-all",
        name: "Default1Page",
        component: Default1Page,
      },
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Users Module
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      // Projects
      {
        path: "/projects",
        name: "ProjectsPage",
        component: ProjectsPage,
      },
      {
        path: "/projects/create",
        name: "ProjectCreatePage",
        component: ProjectCreatePage,
      },
      {
        path: "/projects/:projectId",
        name: "ProjectIdPage",
        component: ProjectIdPage,
      },
      // Templates
      {
        path: "/templates/upload",
        name: "TemplatesUpload",
        component: TemplatesUpload,
      },
      {
        path: "/templates",
        name: "TemplatesPage",
        component: TemplatesPage,
      },
      {
        path: "/templates/create",
        name: "TemplateCreatePage",
        component: TemplateCreatePage,
      },
      {
        path: "/templates/:projectId",
        name: "TemplateIdPage",
        component: TemplateIdPage,
      },
      // Quotations
      {
        path: "/quotations",
        name: "QuotationsPage",
        component: QuotationsPage,
      },
      {
        path: "/quotations/upload",
        name: "QuotationsUpload",
        component: QuotationsUpload,
      },
      {
        path: "/quotations/create",
        name: "QuotationCreatePage",
        component: QuotationCreatePage,
      },
      {
        path: "/quotations/:projectId",
        name: "QuotationIdPage",
        component: QuotationIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/tree",
        name: "ModuleTreePage",
        component: ModuleTreePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Jobs
      {
        path: "/module-jobs",
        name: "ModuleJobsPage",
        component: ModuleJobsPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      // {
      //   path: "/values/upload",
      //   name: "ValuesUpload",
      //   component: ValuesUpload,
      // },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      // {
      //   path: "/value-lists/upload",
      //   name: "ValueListUpload",
      //   component: ValueListUpload,
      // },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // UserPermissions
      {
        path: "/user-permissions",
        name: "UserPermissions",
        component: UserPermissions,
      },
      // Suppliers
      {
        path: "/suppliers",
        name: "SuppliersPage",
        component: SuppliersPage,
      },
      {
        path: "/suppliers/create",
        name: "SupplierCreatePage",
        component: SupplierCreatePage,
      },
      {
        path: "/suppliers/:supplierId",
        name: "SupplierIdPage",
        component: SupplierIdPage,
      },
    ],
  },
  // End RoleLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === "/" || to.path === "/auth/login") {
    if (store.getters["auth/authenticated"] && !to.query.isSupplier) {
      return next({
        path: "/dashboards",
      });
    }
    next();
  } else if (to.path == "/modules/tree") {
    next();
  } else if (!store.getters["auth/authenticated"]) {
    return next({
      path: "/auth/login",
    });
  }
  next();
});

router.afterEach(() => {
  // // Remove initial loading
  // const appLoading = document.getElementById("loading-bg");
  // if (appLoading) {
  //   appLoading.style.display = "none";
  // }
});

export default router;
